/**
 * Calculates the percentage savings between an original price and a discounted price.
 *
 * This function:
 * - Returns a whole number percentage (e.g., 25 for 25%)
 * - Validates inputs: must be positive numbers and discounted must be less than original
 * - Returns `null` if values are invalid or savings do not apply
 *
 * @param original - The original price (before discount)
 * @param discounted - The discounted price (after discount)
 * @returns Percentage saved as a whole number, or null if invalid
 */
export const calculateSavingsPercentage = (
  original: number | null | undefined,
  discounted: number | null | undefined,
): number | null => {
  if (
    original == null ||
    discounted == null ||
    original <= 0 ||
    discounted <= 0 ||
    discounted >= original
  ) {
    return null;
  }

  return Math.round(((original - discounted) / original) * 100);
};
